import type { MouseEvent } from "react";
import { Box, Flex, Popover } from "orcs-design-system";
import styled from "styled-components";

const VerticalDots = styled.div`
  &:hover {
    cursor: pointer;
  }
  &::after {
    content: "︙";
    font-size: 14px;
    display: block;
    text-align: center;
    font-weight: 700;
  }
`;

const StyledP = styled.p`
  width: 100%;
  text-align: left;
  font-size: 1.2rem;
  padding: 0.5rem;
  &:hover {
    background-color: #f0f0f0;
    cursor: pointer;
  }
`;

type ActionMenuProps = {
  handleClickToTheTop: (event: MouseEvent) => void;
};

const ActionMenu = ({ handleClickToTheTop }: ActionMenuProps) => {
  return (
    <Box>
      <Popover
        direction="top"
        width="200px"
        textAlign="center"
        text={
          <Flex
            flexDirection="column"
            justifyContent="start"
            alignItems="start"
            padding="s"
          >
            <StyledP onClick={handleClickToTheTop}>Pin to the top</StyledP>
          </Flex>
        }
      >
        <VerticalDots />
      </Popover>
    </Box>
  );
};

export default ActionMenu;
